import * as React from 'react';

import { CoworkingProfitBannerControlled, CoworkingProfitBannerView } from './internal/components';
import { CoworkingProfitBannerService } from './internal/services';

export const CoworkingProfitBanner: React.FC = () => {
  const [isHoverBehavior, setIsHoverBehavior] = React.useState(CoworkingProfitBannerService.isCoworkingProfitWasShown);

  if (isHoverBehavior) {
    return <CoworkingProfitBannerView />;
  }

  return <CoworkingProfitBannerControlled setIsHoverBehavior={setIsHoverBehavior} />;
};

CoworkingProfitBanner.displayName = 'CoworkingProfitBanner';
